<template>
  <div class="admin-container">
    <!-- 侧边栏 -->
    <div class="sidebar">
      <div class="sidebar-header">
        <h3>管理后台</h3>
        <p>欢迎，{{ user ? user.username : '管理员' }}</p>
        <small class="text-muted">{{ currentTime }}</small>
      </div>
      
      <nav class="sidebar-nav">
        <ul class="nav-list">
          <li class="nav-item">
            <a 
              href="#" 
              :class="{ active: activeMenu === 'products' }"
              @click="setActiveMenu('products')"
            >
              <i class="icon-products"></i>
              产品管理
            </a>
          </li>
        </ul>
      </nav>
      
      <div class="sidebar-footer">
        <button class="btn btn-outline-danger btn-sm" @click="handleLogout">
          <i class="icon-logout"></i>
          退出登录
        </button>
      </div>
    </div>
    
    <!-- 主内容区 -->
    <div class="main-content">
      <div class="content-header">
        <h1>产品管理</h1>
      </div>
      
      <div class="content-body">
        <!-- 产品管理内容 -->
        <div>
          <ProductManagement />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProductManagement from '@/components/ProductManagement.vue'

export default {
  name: 'Admin',
  components: {
    ProductManagement
  },
  data() {
    return {
      activeMenu: 'products',
      currentTime: ''
    }
  },
  computed: {
    ...mapState(['isAuthenticated', 'user', 'products'])
  },
  mounted() {
    // 由于路由守卫已经处理了认证检查，这里只需要更新时间即可
    
    // 更新时间
    this.updateTime()
    setInterval(this.updateTime, 1000)
  },
  methods: {
    ...mapActions(['logout', 'checkAuthStatus']),
    
    setActiveMenu(menu) {
      this.activeMenu = menu
    },
    
    async handleLogout() {
      if (confirm('确定要退出登录吗？')) {
        await this.logout()
        this.$router.push('/login')
      }
    },
    
    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.admin-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f5f5;
  /* 移除padding-top，因为管理页面不显示Header */
}

/* 侧边栏样式 */
.sidebar {
  width: 250px;
  background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%);
  color: white;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.sidebar-header h3 {
  margin: 0 0 10px 0;
  font-size: 20px;
  font-weight: 600;
}

.sidebar-header p {
  margin: 0 0 5px 0;
  opacity: 0.8;
}

.sidebar-nav {
  flex: 1;
  padding: 20px 0;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin-bottom: 5px;
}

.nav-item a {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
}

.nav-item a:hover,
.nav-item a.active {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border-left-color: #3498db;
}

.nav-item a i {
  margin-right: 10px;
  width: 16px;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-footer .btn {
  width: 100%;
  border-color: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.8);
}

.sidebar-footer .btn:hover {
  background-color: #e74c3c;
  border-color: #e74c3c;
  color: white;
}

/* 主内容区样式 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.content-header {
  background: white;
  padding: 20px 30px;
  border-bottom: 1px solid #eee;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.content-header h1 {
  margin: 0;
  color: #2c3e50;
  font-size: 24px;
  font-weight: 600;
}

.content-body {
  flex: 1;
  padding: 30px;
  overflow-y: auto;
}

/* 图标样式 */
.icon-products::before { content: '📦'; }
.icon-logout::before { content: '🚪'; }

/* 响应式设计 */
@media (max-width: 768px) {
  .admin-container {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    height: auto;
  }
  
  .sidebar-nav {
    padding: 10px 0;
  }
  
  .nav-list {
    display: flex;
    overflow-x: auto;
  }
  
  .nav-item {
    margin-bottom: 0;
    margin-right: 5px;
    flex-shrink: 0;
  }
  
  .content-body {
    padding: 20px;
  }
}
</style>